import React from "react";
import StripeProvider from "./StripeProvider";
import PurchaseTickets from "./PurchaseTickets";

export default ({ stripePublicKey, ...props }) => (
  <StripeProvider apiKey={stripePublicKey}>
    <PurchaseTickets {...props} />
  </StripeProvider>
);
